import React from 'react';

interface BobaPearlProps {
  size: number;
  left: number;
  top: number;
  animationDelay: number;
  animationDuration: number;
  color: string;
}

const BobaPearl: React.FC<BobaPearlProps> = ({ size, left, top, animationDelay, animationDuration, color }) => {
  return (
    <div
      className={`absolute rounded-full ${color} opacity-35`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        left: `${left}%`,
        top: `${top}%`,
        animation: `float-boba ${animationDuration}s ease-in-out infinite ${animationDelay}s`,
      }}
    />
  );
};

const FloatingBobaPearls: React.FC = () => {
  // 生成隨機珍珠數據
  const pearls = React.useMemo(() => {
    const pearlsArray = [];
    const pearlCount = 12; // 減少珍珠數量避免過於繁雜
    const maxTop = 75; // 限制珍珠不要太接近底部，防止滑動問題
    
    // 彩色珍珠漸變色選項
    const colors = [
      'bg-gradient-to-br from-pink-400 to-rose-500',
      'bg-gradient-to-br from-blue-400 to-cyan-500',
      'bg-gradient-to-br from-green-400 to-emerald-500',
      'bg-gradient-to-br from-yellow-400 to-orange-500',
      'bg-gradient-to-br from-purple-400 to-violet-500',
      'bg-gradient-to-br from-indigo-400 to-blue-500',
      'bg-gradient-to-br from-red-400 to-pink-500',
      'bg-gradient-to-br from-teal-400 to-cyan-500'
    ];

    for (let i = 0; i < pearlCount; i++) {
      pearlsArray.push({
        id: i,
        size: Math.random() * 16 + 6, // 6-22px 大小（稍微小一點）
        left: Math.random() * 100, // 0-100% 水平位置
        top: Math.random() * maxTop, // 0-85% 垂直位置，避免底部溢出
        animationDelay: Math.random() * 4, // 0-4秒延遲
        animationDuration: Math.random() * 3 + 3, // 3-6秒動畫時間
        color: colors[Math.floor(Math.random() * colors.length)], // 隨機選擇顏色
      });
    }

    return pearlsArray;
  }, []);

  return (
    <div className="absolute inset-0 pointer-events-none z-10 overflow-hidden">
      {pearls.map((pearl) => (
        <BobaPearl
          key={pearl.id}
          size={pearl.size}
          left={pearl.left}
          top={pearl.top}
          animationDelay={pearl.animationDelay}
          animationDuration={pearl.animationDuration}
          color={pearl.color}
        />
      ))}
    </div>
  );
};

export default FloatingBobaPearls;